import { useEffect, useRef } from "react";
import { logEvent } from "@shared/analytics/analytics";

interface PageViewProps {
  pageName: string;
  extraProperties?: Record<string, any>;
}

export const usePageViewTimer = ({ pageName, extraProperties }: PageViewProps) => {
  const startTimeRef = useRef<number | null>(null);

  useEffect(() => {
    startTimeRef.current = Date.now();

    return () => {
      if (startTimeRef.current) {
        const durationMs = Date.now() - startTimeRef.current;
        logEvent(`${pageName} Viewed`, {
          page: pageName,
          durationMs,
          durationSec: Math.round(durationMs / 1000),
          ...extraProperties,
        });
      }
    };
  }, [pageName, JSON.stringify(extraProperties)]);
};
